import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApiService } from '../../service/api_service';

@Component({
    selector: 'app-addchemistmaster',
    template: require('./addchemistmaster.component.html'),
    styles: [require('./addchemistmaster.component.css')],
})

export class AddChemistMasterComponent implements OnInit {

    model: NgbDateStruct;
    ChemistMaster: any;
    empData: any = [];
    AreaList: any = [];
    RouterList: any = [];
    busy: Subscription;
    token:any;

    f_chkString(p_value) {
        var Val = (p_value? p_value.toString(): "").trim();
        return Val;
    }

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if(Num){
            return Num;
        }
        return 0;
    }

    static parameters = [ApiService, ActivatedRoute, Router, HttpClient]
    constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute, private router: Router, private http: HttpClient ) {

    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.getEmployee();
        this.InitEmployee();        
        this.activatedRoute.queryParams.subscribe(params => {
            var _ID = Number(params['id']) ? Number(params['id']) : 0;
            this.ChemistMaster._ID = _ID;
            this.GetEmployeeChemistDetailsByID(_ID);
        });        
    }

    InitEmployee(){
        this.ChemistMaster = {};
        this.ChemistMaster._ID = 0;
        this.ChemistMaster.EmployeeCode = "0";
        this.ChemistMaster.Area_Id = "0";
        this.ChemistMaster.RouteId = "0";
        this.ChemistMaster.ChemistType = "C";
        this.ChemistMaster.Region = "";
        this.ChemistMaster.category = "";
        this.ChemistMaster.VisitFrequency = "1";
        this.ChemistMaster.DealRequired = "0";
        if (this.empData.length > 0) {
            this.ChemistMaster.EmployeeCode = this.empData[0].Client_Code;
            this.OnEmployeeChange();
        }
    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
            if (this.empData.length > 0 && this.ChemistMaster._ID == 0) {
                this.ChemistMaster.EmployeeCode = this.empData[0].Client_Code;
                this.OnEmployeeChange();
            }
        })
    }

    OnEmployeeChange(){
        this.GetEmployeeAreaList();
        this.GetEmployeeRouteList();
        this.ChemistMaster.EmployeeName = "";
        this.ChemistMaster.HQ = "";
        if(this.ChemistMaster.EmployeeCode){
            var EmployeeCode = this.ChemistMaster.EmployeeCode;
            var FempData = this.empData.filter(function(item){ return item.Client_Code == EmployeeCode});
            if(FempData.length > 0){
                this.ChemistMaster.EmployeeName = FempData[0].Client_Name;
                this.ChemistMaster.HQ = FempData[0].HQName;
            }
        }
        
    }

    OnAreaChange(){
        this.ChemistMaster.ChemistArea = "";
        if(this.ChemistMaster.Area_Id){
            var Area_Id = this.ChemistMaster.Area_Id;
            var FAreaList = this.AreaList.filter(function(item){ return item.ID == Area_Id});
            if(FAreaList.length > 0){
                this.ChemistMaster.ChemistArea = FAreaList[0].AreaName;
            }
        }
    }

    OnRouteChange(){
        this.ChemistMaster.RouteName = "";
        if(this.ChemistMaster.RouteId){
            var RouteId = this.ChemistMaster.RouteId;
            var FRouterList = this.RouterList.filter(function(item){ return item.ID == RouteId});
            if(FRouterList.length > 0){
                this.ChemistMaster.RouteName = FRouterList[0].RouteName;
            }
        }
    }

    GetEmployeeAreaList(){
        var data = { "Client_Code": this.ChemistMaster.EmployeeCode };
       this.busy = this.http.post('/api/usermasters/GetEmployeeAreaAgainstClientCode', data).subscribe((res) => {
            this.AreaList = res;
        })
    }

    GetEmployeeRouteList(){
        var data = { "Client_Code": this.ChemistMaster.EmployeeCode };
        this.http.post('/api/usermasters/GetEmployeeRouteAgainstClientCode', data).subscribe((res) => {
            this.RouterList = res;
        })
    }

    GetEmployeeChemistDetailsByID(id){
        var data = { "ID": id };
        this.busy = this.http.post('/api/usermasters/GetEmployeeChemistDetailsByID', data)
        .subscribe((res: any) => {
            if(res.length > 0){
                this.ChemistMaster = Object.assign({}, res[0]);
                this.GetEmployeeAreaList();
                this.GetEmployeeRouteList();
            } else {
                this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { id: 0 }});
                if (this.empData.length > 0) {
                    this.ChemistMaster.EmployeeCode = this.empData[0].Client_Code;
                    this.OnEmployeeChange();
                }
            }
        })
    }

    SaveChemist(event) {
        console.log('this.ChemistMaster: ', this.ChemistMaster);
        this.ChemistMaster.ChemistName = this.f_chkString(this.ChemistMaster.ChemistName);
        this.ChemistMaster.AddressLine = this.f_chkString(this.ChemistMaster.AddressLine);
        this.ChemistMaster.PinCode = this.f_chkString(this.ChemistMaster.PinCode);
        if(!this.ChemistMaster.EmployeeCode){
            alert("Please Select Employee Name");
            return false;
        }

        if((this.ChemistMaster.ChemistName).length == 0){
            alert("Please Enter Chemist Name");
            return false;
        }

        if(this.f_ChkNum(this.ChemistMaster.Area_Id) == 0){
            alert("Please Select Area Name");
            return false;
        }

        if(this.f_ChkNum(this.ChemistMaster.RouteId) == 0){
            alert("Please Select Route Name");
            return false;
        }

        if((this.ChemistMaster.AddressLine).length == 0){
            alert("Please Enter Address Details");
            return false;
        }

        if((this.ChemistMaster.PinCode).length == 0 || (this.ChemistMaster.PinCode).length < 6){
            alert("Please Enter Valid Pincode");
            return false;
        }

        var emailpattern = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$";
        this.ChemistMaster.email = this.f_chkString(this.ChemistMaster.email);
        if(this.ChemistMaster.email.length > 0 && this.ChemistMaster.email.search(emailpattern) == -1) {
            alert('Please Enter Valid Email ID.');
            return false;
        }

        var mobilepattern = /^[0-9][0-9]{9}$/;
        this.ChemistMaster.mobile = this.f_chkString(this.ChemistMaster.mobile);
        if(this.ChemistMaster.mobile.length > 0 && this.ChemistMaster.mobile.search(mobilepattern) == -1 ){
            alert('Please Enter Valid Mobile No.');
            return false;
        }

        this.ChemistMaster.Phone = this.f_chkString(this.ChemistMaster.Phone);
        this.ChemistMaster.ConcernPerson = this.f_chkString(this.ChemistMaster.ConcernPerson);
        let token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.ChemistMaster.clientid=token.id;
        this.busy = this.http.post('/api/usermasters/SaveEmployeeChemistDetails', this.ChemistMaster)
        .subscribe((res: any) => {
            console.log('res: ', res);
            if(res.length > 0){
                if(res[0]["flag"] == 0){
                    alert(res[0]["msg"]);
                } else {
                    this.InitEmployee();
                    this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { id: 0 }});
                    alert(res[0]["msg"]);
                }
            }
        })
    }

    OnVisitFrequencyChange(){
        if(this.ChemistMaster.VisitFrequency == "4"){
            this.ChemistMaster.ChemistType = "A";
        } else if(this.ChemistMaster.VisitFrequency == "2"){
            this.ChemistMaster.ChemistType = "B";
        } else {
            this.ChemistMaster.ChemistType = "C";
        }
    }
}